"use strict";

exports.__esModule = true;


// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

exports.default = capitalizeString;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/internalHelpers/_capitalizeString.js
// module id = 42
// module chunks = 58787633285632 154861247209503 189597454788034